import {
  SweepValueDropdownDocument,
  type SweepValueDropdownQuery,
} from '../../generated/graphql';
import type * as FilterTypes from '../../util/filterTypes';
import type * as RunTypes from '../../util/runTypes';
import {makeInfiniteSelectField} from '../InfiniteScrollDropdown/InfiniteSelectField';

export function isSweepFilterKey(
  filter: FilterTypes.IndividualFilter<RunTypes.Key>
): boolean {
  return (
    filter.key.section === 'run' &&
    (filter.key.name === 'sweep' || filter.key.name === 'sweepName')
  );
}

/**
 * Value field backed by `project.sweeps` (rather than
 * `project.runFieldValues`).
 *
 * The runFieldValues source can only surface sweep names that already
 * have at least one non-internal run, so a freshly-registered sweep is
 * invisible until the first agent run lands. `project.sweeps` reads
 * from the sweeps table directly, so a sweep is pickable the moment
 * it's created. Selector code branches on `isSweepFilterKey(filter)`
 * to choose between this field and the generic
 * `FilterSimpleValueSelectField`.
 */
export const SweepValueSelectField =
  makeInfiniteSelectField<SweepValueDropdownQuery>({
    label: 'Value',
    placeholder: 'Select a sweep',
    searchPlaceholder: 'Search sweeps',
    // Sweep names are stored as JSON strings, like every other run value.
    extractItems: data =>
      data?.project?.sweeps?.edges
        .filter(edge => edge.node.name !== '')
        .map(edge => JSON.stringify(edge.node.name)) ?? [],
    extractPageInfo: data => data?.project?.sweeps?.pageInfo ?? {},
    query: SweepValueDropdownDocument,
    buildSearchVariables: (searchString: string) => ({
      filters:
        searchString === ''
          ? null
          : JSON.stringify({name: {$contains: searchString}}),
      order: '-createdAt',
    }),
  });
